// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#positive-credit-data-consent-modal .dialog-content-container{padding:1em}#positive-credit-data-consent-modal-body{padding:2em;line-height:1.5}#positive-credit-data-consent-modal-body li{margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
